module.exports = __webpack_public_path__ + "img/gallery-add.16ee2059.svg";